import EduLogo from "../components/EduLogo";
import { Star, Mail, Phone } from "lucide-react";

export default function HelpCenter() {
    return (
        <div className="p-6 md:p-10 fade-in">
            <div className="max-w-3xl mx-auto">
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 rounded-xl bg-edu-navy flex items-center justify-center">
                        <Star size={20} className="text-edu-gold" fill="currentColor" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-semibold text-edu-text">Centro de Ayuda</h1>
                        <p className="text-sm text-edu-body">Estamos aquí para ti, en cada paso del aprendizaje.</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4 mb-8">
                    <a href="mailto:soporte@eduperu.pe" className="edu-card p-5 hover:shadow-md transition" data-testid="support-email">
                        <div className="flex items-center gap-3 mb-2">
                            <Mail size={18} className="text-edu-navy" />
                            <h3 className="font-semibold">Email de soporte</h3>
                        </div>
                        <p className="text-sm text-edu-body">soporte@grit.pe</p>
                    </a>
                    <div className="edu-card p-5">
                        <div className="flex items-center gap-3 mb-2">
                            <Phone size={18} className="text-edu-navy" />
                            <h3 className="font-semibold">Teléfono</h3>
                        </div>
                        <p className="text-sm text-edu-body">+51 998683921</p>
                    </div>
                </div>

                <div className="edu-card p-6">
                    <h2 className="text-xl font-semibold mb-3">Libro de reclamaciones</h2>
                    <div className="space-y-4 text-sm text-edu-body">
                        <div>
                            <h4 className="font-semibold text-edu-text">¿Cómo gano monedas?</h4>
                            <p>Enviando recomendaciones aprobadas por el ejecutivo (1 por semana) o cuando el administrador realice una recarga.</p>
                        </div>
                        <div>
                            <h4 className="font-semibold text-edu-text">¿Qué es el estilo de aprendizaje?</h4>
                            <p>Es la forma en que mejor aprendes (visual, auditivo, lector-escritor o kinestésico). Tu psicólogo lo asigna.</p>
                        </div>
                        <div>
                            <h4 className="font-semibold text-edu-text">¿El Tutor IA cobra monedas?</h4>
                            <p>Sí, cada nueva sesión cuesta 5 monedas. Las consultas del colegio son gratis.</p>
                        </div>
                        <div>
                            <h4 className="font-semibold text-edu-text">¿Por qué no puedo enviar otra recomendación?</h4>
                            <p>Cada estudiante puede enviar máximo 1 recomendación por semana. Tu envío queda en estado "Pendiente" hasta que el ejecutivo lo valide.</p>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-8">
                    <EduLogo size="sm" />
                </div>
            </div>
        </div>
    );
}
